<template>
    <div class="cart-container box" :style="isMobile?{width:'100%'}:{}">
        <header>
            我的购物车 <span>共{{total}}门课程</span>
        </header>

        <cart-header @check-all-change="onCheckAllChange" />

        <cart-list />

        <cart-bottom-action @check-all-change="onCheckAllChange" />

    </div>
</template>

<script>
    import {DISPATCH_INIT_CART_LIST} from "@constants/action-type/cart-action-type";
    import {createNamespacedHelpers} from 'vuex'
    import {COMMIT_CHANGE_CART_SELECTED} from "@constants/mutation-type/cart-mutation-type";
    import CartHeader from "@views/pay/components/CartHeader";
    import {deepClone} from "@utils/func";
    import CartList from "@views/pay/components/CartList";
    import CartBottomAction from "@views/pay/components/CartBottomAction";
    import common from "../../mixin/common";

    const {mapState, mapGetters} = createNamespacedHelpers('cart');

    export default {
        name: "ShoppingCart",
        mixins: [common],
        components: {
            CartHeader,
            CartBottomAction,
            CartList
        },
        created() {
            this.$store.dispatch({
                type: DISPATCH_INIT_CART_LIST
            })
        },
        methods: {
            onCheckAllChange() {
                let selectList = [];
                if (!this.checkAll && !this.indeterminate) {
                    // 全选
                    deepClone(this.cartList, selectList);
                }
                this.$store.commit({
                    type: COMMIT_CHANGE_CART_SELECTED,
                    selectList
                })
            },


        },
        computed: {
            ...mapState([
                "cartList",
                "selectList",
                "isLoading"
            ]),
            ...mapGetters([
                "total",
                "checkAll",
                "indeterminate",
                "totalPrice"
            ])
        }
    }
</script>

<style scoped lang="less">
    @import '../../styles/variable.less';

    .cart-container {
        padding: 20px;
    }

    // 标题
    header {
        font-size: 16px;
        line-height: 18px;
        padding: 20px 0;
        font-weight: normal;

        span {
            color: #999;
            font-size: 12px;
        }
    }

    @media screen and (max-width: @screen-lg) {

        header::before {
            content: ' ';
            border-left: 2px solid @primary-color;
            height: 18px;
            margin-right: 5px;
        }
    }


    ;</style>
